var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReporte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reporte"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.22753906 1.1386719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.77175 14.4834L13.3313 14.4834C14.2436 12.9942 15.7364 11.9111 17.4844 11.5658L17.4844 2.17809C17.4844 0.977109 16.5073 0 15.3063 0L13.7467 0L13.7467 0.817969C13.7467 1.90134 12.8652 2.78278 11.7818 2.78278L5.70258 2.78278C4.6192 2.78278 3.73777 1.90134 3.73777 0.817969L3.73777 0L2.17809 0C0.977109 0 0 0.977109 0 2.17809L0 20.5775C0 21.7785 0.977109 22.7556 2.17809 22.7556L14.5746 22.7556C13.23 21.575 12.3771 19.8276 12.3771 17.8808C12.3771 17.203 12.4808 16.5495 12.6723 15.9355L3.77175 15.9355C3.37078 15.9355 3.0457 15.6105 3.0457 15.2095C3.0457 14.8085 3.37078 14.4834 3.77175 14.4834L3.77175 14.4834ZM3.7717 5.9043L13.7137 5.9043C14.1147 5.9043 14.4397 6.22937 14.4397 6.63034C14.4397 7.03131 14.1147 7.35639 13.7137 7.35639L3.7717 7.35639C3.37073 7.35639 3.04565 7.03131 3.04565 6.63034C3.04565 6.22937 3.37073 5.9043 3.7717 5.9043L3.7717 5.9043ZM3.7717 8.76392L13.7137 8.76392C14.1147 8.76392 14.4397 9.08899 14.4397 9.48996C14.4397 9.89093 14.1147 10.216 13.7137 10.216L3.7717 10.216C3.37073 10.216 3.04565 9.89093 3.04565 9.48996C3.04565 9.08899 3.37073 8.76392 3.7717 8.76392L3.7717 8.76392ZM3.7717 11.6238L13.7137 11.6238C14.1147 11.6238 14.4397 11.9489 14.4397 12.3498C14.4397 12.7508 14.1147 13.0759 13.7137 13.0759L3.7717 13.0759C3.37073 13.0759 3.04565 12.7508 3.04565 12.3498C3.04565 11.9489 3.37073 11.6238 3.7717 11.6238L3.7717 11.6238Z",
    id: "Shape",
    fill: "#07C180",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.4179688 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59203 0L0.512766 0C0.230016 0 0 0.230016 0 0.512766L0 1.95661C0 2.23936 0.230016 2.46937 0.512766 2.46937L6.59203 2.46937C6.87478 2.46937 7.1048 2.23936 7.1048 1.95661L7.1048 0.512766C7.1048 0.230016 6.87473 0 6.59203 0L6.59203 0Z",
    id: "Shape",
    fill: "#07C180",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.056641 14.0390625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.85775 0C2.17917 0 0 2.2343 0 4.98061C0 7.72692 2.17917 9.96117 4.85775 9.96117C7.53633 9.96117 9.7155 7.72692 9.7155 4.98061C9.7155 2.2343 7.53633 0 4.85775 0L4.85775 0ZM6.89085 7.70254C6.76049 7.79989 6.60806 7.84691 6.45698 7.84691C6.23573 7.84691 6.01729 7.74617 5.8747 7.5553L4.27617 5.41508C4.18246 5.2896 4.13184 5.13721 4.13184 4.98064L4.13184 3.43039C4.13184 3.02943 4.45691 2.70435 4.85788 2.70435C5.25885 2.70435 5.58388 3.02938 5.58388 3.43035L5.58388 4.73938L7.03809 6.68633C7.27799 7.00761 7.21209 7.46258 6.89085 7.70254L6.89085 7.70254Z",
    id: "Shape",
    fill: "#06AA70",
    fillRule: "evenodd",
    stroke: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporte);
export default __webpack_public_path__ + "static/media/reporte.d62a539ae0ca830500502661d1105157.svg";
export { ForwardRef as ReactComponent };